import { useEffect } from "react";
import { signInAndUp } from "supertokens-web-js/recipe/thirdparty";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useUiStore } from "@/stores/UiStore";
import LogoLoader from "@/ui/LogoLoader";

const GoogleAuthCallback = () => {
  const navigate = useNavigate();

  const redirectUrl = useUiStore((state) => state.redirectUrl);
  const redirectToPath = redirectUrl || "/home";

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        const response = await signInAndUp();

        if (response.status === "OK") {
          toast.success("Successfully signed in!");
          navigate(redirectToPath, { replace: true });
        } else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
          toast.error(response.reason);
          navigate("/auth/signin");
        } else {
          toast.error(
            "No email provided by social login. Please use another form of login"
          );
          navigate("/auth/signin");
        }
      } catch (err) {
        if (err.isSuperTokensGeneralError === true) {
          toast.error(err.message);
        } else {
          toast.error("Oops! Something went wrong.");
        }
        navigate("/auth/signin");
      }
    };

    handleGoogleCallback();
    return () => {
      useUiStore.setState({ redirectUrl: null });
    };
  }, [navigate, redirectToPath]);

  return (
    <div className="flex items-center justify-center h-screen w-screen">
      <Toaster position="top-center" reverseOrder={false} />
      <LogoLoader />
    </div>
  );
};

export default GoogleAuthCallback;
